import { InputHourProps, typedMemo } from "src/types";
import { InputText } from "../input-text/input-text";
import { ClockIcon } from "src/assets";
import "./input-hour.scss";

export const InputHour = typedMemo((props: InputHourProps) => {
  return <InputText type="time" icon={ClockIcon} iconValid="" {...props} />;
});
